import { tss } from 'tss-react';

export const getEdgeStyles = tss.create({
  edgeLabel: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    transformOrigin: 'center',
    fontFamily: 'Lexend',
    fontSize: '10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    paddingBottom: '15px',
    backgroundColor: 'white',
    borderRadius: '4px',
    padding: '2px 4px',
    pointerEvents: 'all'
  },
  simplifiedLabel: {
    fontSize: '18px'
  }
});
